let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bocnq")).then(() => parcelRequire('bmmvL'));